import React from 'react';
import slug from 'slug';

import arrowDownIcon from '@/static/images/arrowdown.svg';
import { basesUrl } from '@/lib/BasesUrl';
import { IStaticLocale } from '@/interfaces/staticlocale';
import { IPagesWithCategories } from '@/interfaces/page';

type Props = {
  pathLang: string;
  locale: IStaticLocale;
  page: IPagesWithCategories;
  language: string;
};

const Page = (props: Props) => {
  const { pathLang, locale, page, language } = props;

  const prefixPath = pathLang === '' ? `/${language}/` : pathLang;

  return (
    <div>
      <a
        href={`${prefixPath}${basesUrl.productsByCategory}/${slug(
          page.categoryNamePT
        )}`}
        className="main-content typ-1"
      >
        <p>{page.menu || page.name}</p>
        <img src={arrowDownIcon} alt={locale.header.arrow_down_icon} />
      </a>

      <div className="anim-drop-down submenu">
        {page.products.map(({ id, name, currentPath }) => (
          <a className="anim-drop-down-item" key={id} href={currentPath}>
            {name}
          </a>
        ))}
      </div>
    </div>
  );
};

export default Page;
